import React, { useState } from 'react';
import './AddOpportunityModal.css';
import { fetchWithAuth } from './utils';

interface AddOpportunityModalProps {
  isOpen: boolean;
  onClose: () => void;
  regionCode: string;
  onSaveSuccess: () => void;
}

const AddOpportunityModal: React.FC<AddOpportunityModalProps> = ({
  isOpen,
  onClose,
  regionCode,
  onSaveSuccess,
}) => {
  const [formData, setFormData] = useState({
    region_code: regionCode,
    project_name: '',
    start_date: '',
    due_date: '',
    priority: '',
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      const userToken = localStorage.getItem('userToken');
      let username = '';
      if (userToken) {
        const parsedToken = JSON.parse(userToken);
        username = parsedToken?.username || '';
      }

      const payload = {
        ...formData,
        status: 'Forecasted',
        created_by: username,
        proposal_number: 'OPENPROPOSAL',
        proposal_owner: username,
        scope_description: formData.project_name,
        client_name: formData.project_name,
        project_code: 'Open',
      };

      const url =
        'https://manningserviceapp.azurewebsites.net/api/MainRoute?code=GUgZKUh3at7CoJZqYItK4T3zUXK_aJred4q-7EIwAkGMAzFuYSmcaQ==&action=add_opportunity';

      const result = await fetchWithAuth(url, {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (result?.status?.trim().toLowerCase() === 'success') {
        onSaveSuccess();
        onClose();
      } else {
        console.error('Failed to save opportunity');
      }
    } catch (error) {
      console.error('Error saving opportunity:', error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Add Opportunity</h2>
        <div className="form-grid">
          <label>
            Region Code:
            <input name="region_code" value={formData.region_code} readOnly />
          </label>
          <label>
            Project Name:
            <input name="project_name" value={formData.project_name} onChange={handleChange} />
          </label>
          <label>
            Start Date:
            <input type="date" name="start_date" value={formData.start_date} onChange={handleChange} />
          </label>
          <label>
            Due Date:
            <input type="date" name="due_date" value={formData.due_date} onChange={handleChange} />
          </label>
          <label>
            Priority:
            <select name="priority" value={formData.priority} onChange={handleChange}>
              <option value="">-- Select Priority --</option>
              <option value="Urgent">Urgent</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low">Low</option>
            </select>
          </label>
        </div>

        <div className="modal-buttons">
          <button onClick={handleSave} className="save-button">
            Save
          </button>
          <button onClick={onClose} className="save-button">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOpportunityModal;
